import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteesTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'datePaid',
];

const optionalColumnLabelFormat = {
  datePaid: 'Date Paid',
};

const PaidPreApprovalGuarantees = (
  { TabsRaw }: any,
) => (
  <GuaranteesTableRecords
    type="pre-approval"
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    tabStatus="PAID"
    defaultUrl={AdminRouteName.paidPreApprovalGuaranteesRoute}
    toggleStorageId="paid-pre-approval-guarantees-table-col"
    hasNameAndImage
    permissionName="can-view-paid-guarantees"
  />
);
export default PaidPreApprovalGuarantees;
